import { InjectionToken } from '@angular/core';

export const PROPOSALS_BASE_PATH = new InjectionToken<string>(
  'Base path for proposals micro-site'
);

export const PROPOSALS_MOCK_IDS = new InjectionToken<string[]>(
  'Array of proposal config ids which uses mocks'
);

export const PROPOSALS_MOCKS = new InjectionToken<unknown[]>(
  'Array of proposals mocks for current portal'
);
